exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.video-title{height:66px;overflow:hidden}}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/apps/client/app/components/apps/videoItem/videoItem.scss"],"names":[],"mappings":"AAIE,yBAFF,aAGI,YACA,eAAgB,CAEnB,CAAA","file":"videoItem.scss","sourcesContent":["@import \"~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss\";\n\n.video-title {\n  // styles for tablet\n  @media (min-width: $screen-sm-min) {\n    height: 66px;\n    overflow: hidden;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./client/app/components/apps/videoItem/videoItem.scss
// module id = 572
// module chunks = 0